import Ajax from '../js/common/ajax';

const BASE = '/accounting/reference-fact-types/config';

export default {
  /** 列表：返回当前账套 + 全局所有类型 */
  list() {
    return Ajax.get(BASE);
  },

  /** 受控枚举：semanticRole 值表 */
  getSemanticRoles() {
    return Ajax.get(`${BASE}/semantic-roles`);
  },

  /** 详情：type 元数据 + fields 数组 */
  detail(factTypeCode) {
    return Ajax.get(`${BASE}/${encodeURIComponent(factTypeCode)}`);
  },

  /** 新建账套级类型 */
  create(data) {
    return Ajax.postJson(BASE, data);
  },

  /** 修改 type 元数据（name / businessDomain / applicableEventTypes） */
  updateType(factTypeCode, data) {
    return Ajax.put(`${BASE}/${encodeURIComponent(factTypeCode)}`, data);
  },

  /**
   * 批量替换字段
   * @param {string} factTypeCode
   * @param {Array}  fields
   * @param {boolean} force  — 有引用数据时须传 true
   */
  saveFields(factTypeCode, fields, force = false) {
    return Ajax.postJson(
      `${BASE}/${encodeURIComponent(factTypeCode)}/fields?force=${force}`,
      { fields }
    );
  },

  /** 归档 */
  archive(factTypeCode) {
    return Ajax.post(`${BASE}/${encodeURIComponent(factTypeCode)}/archive`);
  },

  /** 还原 */
  restore(factTypeCode) {
    return Ajax.post(`${BASE}/${encodeURIComponent(factTypeCode)}/restore`);
  },

  /**
   * 物理删除（仅账套级）
   * @param {boolean} force
   */
  remove(factTypeCode, force = false) {
    return Ajax.delete(`${BASE}/${encodeURIComponent(factTypeCode)}?force=${force}`);
  },

  /**
   * 从全局模板克隆到当前账套
   * @param {string} factTypeCode      全局模板 code
   * @param {string} newFactTypeCode   新 code（可选，默认用原 code）
   */
  cloneFromTemplate(factTypeCode, newFactTypeCode) {
    const body = { factTypeCode };
    if (newFactTypeCode && newFactTypeCode !== factTypeCode) {
      body.newFactTypeCode = newFactTypeCode;
    }
    return Ajax.postJson(`${BASE}/clone-from-template`, body);
  }
};
